module.exports = __webpack_public_path__ + "img/OutdoorChannel.fcd13652.png";